import * as React from "react";
import styles from "./styles";
export default (props) => (React.createElement("div", { style: styles.container },
    React.createElement("div", { onClick: props.onDecrement, style: styles.decrement }, "-"),
    React.createElement("div", { style: styles.quantity }, props.quantity),
    React.createElement("div", { style: styles.increment, onClick: props.onIncrement }, "+")));
